import TipCard from './TipCard'

export default TipCard
